module.exports = __webpack_public_path__ + "img/tqbs.657f11fb.svg";